import { BaseModel } from './base.model';
import { dcDataStoreItem } from './datastore-item.model';
import { dcHierarchy } from './dcHierarchyTVP';
import { dcTag } from './dcTag.model';
import { Dictionary } from './dictionary';
import { KeyValuePair } from './key-value-pair';
import { LoggingDetails } from './log-settings.model';
import { dcSuggestedValue } from './suggested-value.model';
import { ActionableProcessHeader } from './workflow/actionable-process-header.model';

export class User extends BaseModel implements dcDataStoreItem {
    Key: string;
    UserSecurityID: number;
    UserID: number;
    LoginID: string;
    FirstName: string;
    LastName: string;
    Email: string;
    RoleAssignments: RoleAssignment[];
    Tags: Array<dcTag>;
    UserMenuTags: Array<dcTag>;
    DefaultRoleID: number;
    JoiningDate: Date;
    DefaultRoleAssignmentID: number;
    Setting: UserSetting;
    UserSessionID: string;
    NXToken: string;
    NXTokenExpiry: Date;
    FrequentlySearched: dcTag[];
    FavoriteApps: dcTag[];
    Contact: string;
    isSelected: boolean;
    DefaultLogSubscriptions: KeyValuePair<LoggingDetails>;
    UserLogSubscriptions: KeyValuePair<LoggingDetails>;
    IsProfilingEnabled: boolean;
    UserApps: dcTag[];
}

export class Token {
    access_token: string;
    token_type: string;
    expires_in: number;
    userName: string;
}

export class Role {
    RoleID: number;
    SecurityID: number;
    RoleName: string;
    ShortName: string;
    HierarchyType: number;
    Description: string;
    ExpiresOn: string;
    Tags: Array<dcTag>;
    isSelected = false;
    RolePermissions: Dictionary<Array<dcTag>>;
    SupportedHierarchy?: dcHierarchy[];

    //RoleAssign: RoleAssignment;
    RoleType: string;
    IsDefault = false;
    StartDate: Date;
    EndDate: Date;
    CAPACITY: number;
    rolePermissionTags: dcTag[];
    processDesignElements: ActionableProcessHeader[];
    SupportedElementTypeList: dcSuggestedValue[];
    ShowSDKNotificationConfig = false;
    ShowReleaseNotes = false;
}

export class RoleAssignment {
    RoleAssignID: number;
    RoleType: string;
    IsDefault = false;
    StartDate: Date;
    EndDate: Date;
    CAPACITY: number;
    Role: Role;
    Scope: Permissions;
    IsDefaultRole = false;
    Is_Group = false;
    GroupName: string;
    HierarchyType: number;
}

export class Permissions {
    Tags: dcTag[];
    ReadOnly: dcTag[];
    ReadWrite: dcTag[];

    constructor() {
        this.ReadOnly = [];
        this.ReadWrite = [];
    }
}

export class UserSetting {
    public DateFormat: string;
    public DateTimeFormat: string;
    public SpeedThreshold: number;
    public DisableWidgetScroll: boolean;
}
